/**
 * Datos semilla iniciales para DOMI-CARE
 * Permite ejecutar la aplicación inmediatamente en Modo Demo / Offline 
 * con casos clínicos representativos del sistema de salud argentino.
 */

export const SEED_DATA = {
  pacientes: [
    {
      id: 'PAC-001',
      dni: '24189340',
      nombreCompleto: 'Roberto Carlos Gómez',
      fechaNacimiento: '1954-08-14',
      edad: 72,
      genero: 'Masculino',
      telefono: '+54 11 4455-8899',
      direccion: 'Av. Rivadavia 6520, Piso 3 Depto B',
      localidad: 'Caballito',
      provincia: 'CABA',
      geolocalizacion: '-34.6231, -58.4489',
      indicacionesLlegada: 'Timbre Gómez. Ascensor amplio apto camilla, rampa de acceso en portal.',
      obraSocial: 'PAMI',
      numeroAfiliado: '150493820100',
      planCobertura: 'Veteranos / Complejo',
      estadoAutorizacion: 'Autorizado',
      nivelComplejidad: 'Alta Complejidad',
      fechaIngreso: '2024-01-15',
      estado: 'Activo',
      diagnosticoPrincipal: { code: 'I69.3', desc: 'Secuelas de infarto cerebral (ACV isquémico con hemiplejía derecha)' },
      diagnosticosSecundarios: [
        { code: 'J44.9', desc: 'EPOC con dependencia de oxígeno suplementario' },
        { code: 'L89.1', desc: 'Úlcera por presión en sacro Estadío II' }
      ],
      pam: {
        objetivos: 'Mantener permeabilidad de vía aérea, rehabilitación motora de miembro superior e inferior derecho, curación avanzada de UPP sacra y prevención de broncoaspiración.',
        frecuenciaVisitas: 'Médico (2x/sem), Kinesiología respiratoria/motora (5x/sem), Enfermería (2x/día 12hs), Fonoaudiología (2x/sem)'
      },
      accesibilidad: {
        cuidadorNombre: 'Mariana Gómez',
        cuidadorVinculo: 'Hija',
        cuidadorTelefono: '+54 11 9988-7766',
        cuidadorResponsableLegal: true,
        tipoVivienda: 'Departamento',
        pisoEscaleraAscensor: 'Piso 3 con ascensor apto camilla',
        espacioCamaOrtopedica: true,
        electricidadEstable: true,
        aguaPotable: true,
        gasNatural: true,
        calefaccion: true,
        banoAdaptado: true,
        enchufeO2: true,
        observaciones: 'Habitación amplia, ventilada, tomacorriente dedicado con disyuntor para concentrador.'
      }
    },
    {
      id: 'PAC-002',
      dni: '18392104',
      nombreCompleto: 'Margarita Elena Rossi',
      fechaNacimiento: '1948-03-22',
      edad: 78,
      genero: 'Femenino',
      telefono: '+54 11 5566-7788',
      direccion: 'Calle Las Heras 1845',
      localidad: 'Vicente López',
      provincia: 'Buenos Aires',
      geolocalizacion: '-34.5298, -58.4821',
      indicacionesLlegada: 'Casa de una planta, entrada con cochera directa a dormitorio.',
      obraSocial: 'OSDE',
      numeroAfiliado: '9403819002',
      planCobertura: 'Plan 410',
      estadoAutorizacion: 'Autorizado',
      nivelComplejidad: 'Mediana Complejidad',
      fechaIngreso: '2024-02-01',
      estado: 'Activo',
      diagnosticoPrincipal: { code: 'S72.0', desc: 'Fractura del cuello del fémur (Post-quirúrgico prótesis total de cadera)' },
      diagnosticosSecundarios: [
        { code: 'I10', desc: 'Hipertensión arterial esencial' },
        { code: 'G30.9', desc: 'Enfermedad de Alzheimer en fase inicial' }
      ],
      pam: {
        objetivos: 'Bipedestación asistida, fortalecimiento de cuádriceps, control de herida quirúrgica y pautas de neuroestimulación cognitiva.',
        frecuenciaVisitas: 'Médico (1x/sem), Kinesiología motora (3x/sem), Enfermería (días alternos para curación y signos vitales)'
      },
      accesibilidad: {
        cuidadorNombre: 'Horacio Rossi',
        cuidadorVinculo: 'Esposo',
        cuidadorTelefono: '+54 11 3322-1144',
        cuidadorResponsableLegal: true,
        tipoVivienda: 'Casa en planta baja',
        pisoEscaleraAscensor: 'Sin desniveles ni escalones',
        espacioCamaOrtopedica: true,
        electricidadEstable: true,
        aguaPotable: true,
        gasNatural: true,
        calefaccion: true,
        banoAdaptado: true,
        enchufeO2: true,
        observaciones: 'Barrales de sujeción instalados en baño y pasillo de acceso.'
      }
    },
    {
      id: 'PAC-003',
      dni: '31908221',
      nombreCompleto: 'Juan Ignacio Peralta',
      fechaNacimiento: '1985-11-04',
      edad: 40,
      genero: 'Masculino',
      telefono: '+54 11 6789-0123',
      direccion: 'Juramento 2480, Piso 8',
      localidad: 'Belgrano',
      provincia: 'CABA',
      geolocalizacion: '-34.5612, -58.4560',
      indicacionesLlegada: 'Edificio moderno con seguridad las 24hs.',
      obraSocial: 'Swiss Medical',
      numeroAfiliado: 'SM-8849102-01',
      planCobertura: 'Black / Corporativo',
      estadoAutorizacion: 'Autorizado',
      nivelComplejidad: 'Baja Complejidad',
      fechaIngreso: '2024-03-10',
      estado: 'Activo',
      diagnosticoPrincipal: { code: 'T81.4', desc: 'Infección quirúrgica de partes blandas en tratamiento antibiótico EV' },
      diagnosticosSecundarios: [
        { code: 'E11.5', desc: 'Diabetes tipo 2 normoglicémica' }
      ],
      pam: {
        objetivos: 'Administración de Ceftriaxona 2g EV diaria por catéter periférico con bomba de infusión, curación estéril de acceso venoso y control de laboratorio.',
        frecuenciaVisitas: 'Enfermería (1x/día infusión), Médico (1x/semana control evolutivo)'
      },
      accesibilidad: {
        cuidadorNombre: 'Luciana Meller',
        cuidadorVinculo: 'Cónyuge',
        cuidadorTelefono: '+54 11 8899-3322',
        cuidadorResponsableLegal: true,
        tipoVivienda: 'Departamento',
        pisoEscaleraAscensor: 'Ascensor doble',
        espacioCamaOrtopedica: false,
        electricidadEstable: true,
        aguaPotable: true,
        gasNatural: true,
        calefaccion: true,
        banoAdaptado: false,
        enchufeO2: false,
        observaciones: 'No requiere aparatología pesada, solo soporte de suero y bomba portátil.'
      }
    }
  ],

  prestadores: [
    {
      id: 'PREST-001',
      dni: '30123456',
      nombre: 'Dra. Silvina Morales',
      disciplina: 'Médico Coordinador',
      matricula: 'MN 114520',
      provincia: 'Nacional',
      telefono: '+54 11 9988-1122',
      email: 'dra.morales@domicare.com',
      zona: 'CABA / Zona Norte',
      estado: 'Activo'
    },
    {
      id: 'PREST-002',
      dni: '34876543',
      nombre: 'Lic. Martín Benítez',
      disciplina: 'Kinesiología y Fisiatría',
      matricula: 'MP 8842',
      provincia: 'Prov. Bs As',
      telefono: '+54 11 8877-2233',
      email: 'lic.benitez@domicare.com',
      zona: 'Zona Norte',
      estado: 'Activo'
    },
    {
      id: 'PREST-003',
      dni: '32987123',
      nombre: 'Enf. Carla Romero',
      disciplina: 'Enfermería Profesional',
      matricula: 'MN 89410',
      provincia: 'Nacional',
      telefono: '+54 11 7766-3344',
      email: 'enf.romero@domicare.com',
      zona: 'CABA',
      estado: 'Activo'
    },
    {
      id: 'PREST-004',
      dni: '35678912',
      nombre: 'Lic. Sofía Albarracín',
      disciplina: 'Fonoaudiología',
      matricula: 'MN 4512',
      provincia: 'Nacional',
      telefono: '+54 11 6655-4433',
      email: 'lic.albarracin@domicare.com',
      zona: 'CABA / San Martín',
      estado: 'Activo'
    },
    {
      id: 'PREST-005',
      dni: '28456123',
      nombre: 'Dr. Federico Varela',
      disciplina: 'Auditor Médico',
      matricula: 'MN 95412',
      provincia: 'Nacional',
      telefono: '+54 11 2233-4455',
      email: 'auditor@prepaga.com',
      zona: 'Central',
      estado: 'Activo'
    }
  ],

  agendaHoy: [
    {
      id: 'VIS-101',
      patientId: 'PAC-001',
      pacienteNombre: 'Roberto Carlos Gómez',
      prestadorId: 'PREST-003',
      prestadorNombre: 'Enf. Carla Romero',
      disciplina: 'Enfermería',
      hora: '09:00',
      direccion: 'Av. Rivadavia 6520, Caballito',
      motivo: 'Curación de UPP sacra, administración medicación y control de signos vitales',
      codigoNomenclador: 'NOM-420101 (Curación Compleja / Enfermería)',
      estado: 'Realizada',
      horaEfectiva: '09:12',
      gps: '-34.6231, -58.4489'
    },
    {
      id: 'VIS-102',
      patientId: 'PAC-001',
      pacienteNombre: 'Roberto Carlos Gómez',
      prestadorId: 'PREST-002',
      prestadorNombre: 'Lic. Martín Benítez',
      disciplina: 'Kinesiología',
      hora: '11:30',
      direccion: 'Av. Rivadavia 6520, Caballito',
      motivo: 'Kinesioterapia respiratoria y movilización pasiva de extremidades',
      codigoNomenclador: 'NOM-250102 (Kinesioterapia Respiratoria Domicilio)',
      estado: 'Pendiente',
      horaEfectiva: null,
      gps: null
    },
    {
      id: 'VIS-103',
      patientId: 'PAC-002',
      pacienteNombre: 'Margarita Elena Rossi',
      prestadorId: 'PREST-002',
      prestadorNombre: 'Lic. Martín Benítez',
      disciplina: 'Kinesiología',
      hora: '14:00',
      direccion: 'Calle Las Heras 1845, Vicente López',
      motivo: 'Reeducación de la marcha con andador y fortalecimiento muscular post-quirúrgico',
      codigoNomenclador: 'NOM-250101 (Rehabilitación Motora Domiciliaria)',
      estado: 'Pendiente',
      horaEfectiva: null,
      gps: null
    },
    {
      id: 'VIS-104',
      patientId: 'PAC-003',
      pacienteNombre: 'Juan Ignacio Peralta',
      prestadorId: 'PREST-003',
      prestadorNombre: 'Enf. Carla Romero',
      disciplina: 'Enfermería',
      hora: '16:30',
      direccion: 'Juramento 2480, Belgrano',
      motivo: 'Administración EV Ceftriaxona 2g y recambio de conector luer-lock',
      codigoNomenclador: 'NOM-420105 (Terapia Infusional Domiciliaria)',
      estado: 'Pendiente',
      horaEfectiva: null,
      gps: null
    }
  ],

  evolucionesHCD: [
    {
      id: 'EVO-001',
      patientId: 'PAC-001',
      fechaHora: '2024-03-14 09:30',
      prestadorNombre: 'Enf. Carla Romero',
      disciplina: 'Enfermería',
      matricula: 'MN 89410',
      subjetivoObjetivo: 'Paciente lúcido, reactivo al llamado. Ventilando con cánula nasal a 2 lpm. Se observa lesión sacra de 3x2 cm con lecho granulante al 70%, sin exudado fétido.',
      evaluacionDiagnostica: 'Evolución favorable de úlcera por presión en sacro (Estadío II en fase proliferativa). Control hemodinámico dentro de parámetros esperados.',
      planTratamiento: 'Limpieza con solución fisiológica estéril, colocación de apósito hidrocoloide DuoDERM y fijación con film transparente. Rotación decúbito c/2hs.',
      practicasRealizadas: 'Curación plana avanzada, control de signos vitales, administración de Enoxaparina 40mg SC.',
      firmas: {
        profesional: 'data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22200%22%20height%3D%2260%22%3E%3Cpath%20d%3D%22M10%2040%20Q%2050%2010%2090%2040%20T%20170%2030%22%20stroke%3D%22%230284c7%22%20stroke-width%3D%222.5%22%20fill%3D%22none%22%2F%3E%3C%2Fsvg%3E',
        familiar: 'data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22200%22%20height%3D%2260%22%3E%3Cpath%20d%3D%22M15%2035%20Q%2060%2045%20100%2025%20T%20180%2035%22%20stroke%3D%22%23334155%22%20stroke-width%3D%222.5%22%20fill%3D%22none%22%2F%3E%3C%2Fsvg%3E',
        aclaracionFamiliar: 'Mariana Gómez (Hija - DNI 33120491)'
      },
      gps: '-34.6231, -58.4489'
    },
    {
      id: 'EVO-002',
      patientId: 'PAC-001',
      fechaHora: '2024-03-13 15:00',
      prestadorNombre: 'Dra. Silvina Morales',
      disciplina: 'Médico Coordinador',
      matricula: 'MN 114520',
      subjetivoObjetivo: 'Visita médica de coordinación. Familiar refiere buen descanso nocturno. Abdomen blando, depresible, ruidos hidroaéreos positivos. Buena tolerancia a dieta semisólida.',
      evaluacionDiagnostica: 'Secuela de ACV estable. EPOC compensado. Riesgo nutricional moderado.',
      planTratamiento: 'Continuar con PAM actual. Se solicita prórroga de kinesiología motora y fonoaudiología a PAMI por 30 días. Ajustar dosis de Enalapril a 10mg/día.',
      practicasRealizadas: 'Examen físico completo, auscultación cardiopulmonar, revisión de medicación.',
      firmas: {
        profesional: 'data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22200%22%20height%3D%2260%22%3E%3Cpath%20d%3D%22M12%2030%20Q%2070%205%20120%2040%20T%20190%2020%22%20stroke%3D%22%230284c7%22%20stroke-width%3D%222.5%22%20fill%3D%22none%22%2F%3E%3C%2Fsvg%3E',
        familiar: 'data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22200%22%20height%3D%2260%22%3E%3Cpath%20d%3D%22M20%2040%20Q%2080%2020%20130%2045%20T%20175%2030%22%20stroke%3D%22%23334155%22%20stroke-width%3D%222.5%22%20fill%3D%22none%22%2F%3E%3C%2Fsvg%3E',
        aclaracionFamiliar: 'Mariana Gómez (Hija - DNI 33120491)'
      },
      gps: '-34.6231, -58.4489'
    }
  ],

  signosVitalesHistorico: [
    {
      id: 'SV-001',
      patientId: 'PAC-001',
      fechaHora: '2024-03-14 09:15',
      sistolica: 130,
      diastolica: 85,
      frecuenciaCardiaca: 76,
      saturacionO2: 95,
      temperatura: 36.6,
      glucemia: 110,
      dolorEVA: 2,
      observaciones: 'Oxígeno a 2 lpm por cánula nasal. Sin disnea.'
    },
    {
      id: 'SV-002',
      patientId: 'PAC-001',
      fechaHora: '2024-03-13 14:45',
      sistolica: 135,
      diastolica: 88,
      frecuenciaCardiaca: 82,
      saturacionO2: 94,
      temperatura: 36.8,
      glucemia: 124,
      dolorEVA: 3,
      observaciones: 'Dolor leve en región glútea al lateralizar.'
    },
    {
      id: 'SV-003',
      patientId: 'PAC-002',
      fechaHora: '2024-03-13 11:00',
      sistolica: 125,
      diastolica: 80,
      frecuenciaCardiaca: 72,
      saturacionO2: 98,
      temperatura: 36.4,
      glucemia: 98,
      dolorEVA: 4,
      observaciones: 'Dolor articular mecánico al iniciar marcha asistida.'
    }
  ],

  escalasHistorico: [
    {
      id: 'ESC-001',
      patientId: 'PAC-001',
      fechaHora: '2024-03-10',
      tipo: 'Braden',
      puntaje: 12,
      clasificacion: 'Riesgo Alto',
      color: '#ef4444',
      detalles: {
        percepcionSensorial: 2,
        humedad: 2,
        actividad: 1,
        movilidad: 2,
        nutricion: 3,
        friccionCizalla: 2
      }
    },
    {
      id: 'ESC-002',
      patientId: 'PAC-001',
      fechaHora: '2024-03-10',
      tipo: 'Barthel',
      puntaje: 25,
      clasificacion: 'Dependencia Grave',
      color: '#f97316',
      detalles: {
        comer: 5,
        lavarse: 0,
        vestirse: 0,
        arreglarse: 0,
        deposicion: 5,
        miccion: 5,
        retrete: 0,
        trasladarse: 5,
        deambulacion: 5,
        escaleras: 0
      }
    },
    {
      id: 'ESC-003',
      patientId: 'PAC-001',
      fechaHora: '2024-03-10',
      tipo: 'Morse',
      puntaje: 55,
      clasificacion: 'Riesgo Alto de Caída',
      color: '#ef4444',
      detalles: {
        historialCaidas: 25,
        diagnosticoSecundario: 15,
        ayudaDeambular: 15,
        viaEndovenosa: 0,
        marcha: 0,
        estadoMental: 0
      }
    }
  ],

  medicamentos: [
    {
      id: 'MED-001',
      patientId: 'PAC-001',
      farmaco: 'Enoxaparina Sódica',
      dosis: '40 mg',
      via: 'Subcutánea (SC)',
      frecuencia: 'Cada 24 hs (09:00)',
      stockActual: 4,
      consumoDiario: 1,
      diasRestantes: 4,
      alerta: 'critico' // < 5 días
    },
    {
      id: 'MED-002',
      patientId: 'PAC-001',
      farmaco: 'Enalapril',
      dosis: '10 mg',
      via: 'Oral',
      frecuencia: 'Cada 12 hs (08:00 - 20:00)',
      stockActual: 28,
      consumoDiario: 2,
      diasRestantes: 14,
      alerta: 'normal'
    },
    {
      id: 'MED-003',
      patientId: 'PAC-001',
      farmaco: 'Salbutamol + Bromuro de Ipratropio',
      dosis: '2 puff',
      via: 'Inhalatoria c/aerocámara',
      frecuencia: 'Cada 8 hs (08:00 - 16:00 - 00:00)',
      stockActual: 1, // Frasco
      consumoDiario: 0.1,
      diasRestantes: 10,
      alerta: 'normal'
    },
    {
      id: 'MED-004',
      patientId: 'PAC-003',
      farmaco: 'Ceftriaxona',
      dosis: '2 g',
      via: 'Endovenosa (EV en frasco SF 100ml)',
      frecuencia: 'Cada 24 hs (16:30)',
      stockActual: 2,
      consumoDiario: 1,
      diasRestantes: 2,
      alerta: 'urgente'
    }
  ],

  equipamientoComodato: [
    {
      id: 'EQ-001',
      patientId: 'PAC-001',
      pacienteNombre: 'Roberto Carlos Gómez',
      tipo: 'Concentrador de Oxígeno 5 LPM',
      marca: 'DeVilbiss Healthcare',
      numeroSerie: 'SN-DEV-8849201',
      fechaEntrega: '2024-01-16',
      ultimoService: '2024-02-15',
      proximoService: '2024-05-15',
      estado: 'Operativo',
      remito: 'REM-2024-0049'
    },
    {
      id: 'EQ-002',
      patientId: 'PAC-001',
      pacienteNombre: 'Roberto Carlos Gómez',
      tipo: 'Cama Ortopédica Eléctrica con Colchón Antiescaras de Presión Alternante',
      marca: 'Drive Medical Med/Air',
      numeroSerie: 'SN-DRV-194022',
      fechaEntrega: '2024-01-16',
      ultimoService: '2024-01-16',
      proximoService: '2024-07-16',
      estado: 'Operativo',
      remito: 'REM-2024-0050'
    },
    {
      id: 'EQ-003',
      patientId: 'PAC-001',
      pacienteNombre: 'Roberto Carlos Gómez',
      tipo: 'Aspirador de Secreciones Portátil',
      marca: 'Apex VacPro',
      numeroSerie: 'SN-APX-7741',
      fechaEntrega: '2024-01-18',
      ultimoService: '2024-02-20',
      proximoService: '2024-06-20',
      estado: 'Operativo',
      remito: 'REM-2024-0062'
    },
    {
      id: 'EQ-004',
      patientId: 'PAC-002',
      pacienteNombre: 'Margarita Elena Rossi',
      tipo: 'Andador de Cuatro Ruedas con Asiento y Frenos',
      marca: 'Silfab Orto',
      numeroSerie: 'SN-SIL-3392',
      fechaEntrega: '2024-02-02',
      ultimoService: '2024-02-02',
      proximoService: '2024-08-02',
      estado: 'Operativo',
      remito: 'REM-2024-0115'
    },
    {
      id: 'EQ-005',
      patientId: 'PAC-003',
      pacienteNombre: 'Juan Ignacio Peralta',
      tipo: 'Bomba de Infusión Continua Volumétrica',
      marca: 'B. Braun Infusomat Space',
      numeroSerie: 'SN-BBR-44910',
      fechaEntrega: '2024-03-10',
      ultimoService: '2024-03-01',
      proximoService: '2024-09-01',
      estado: 'Operativo',
      remito: 'REM-2024-0204'
    }
  ],

  insumosStock: [
    {
      id: 'INS-001',
      patientId: 'PAC-001',
      nombre: 'Apósitos Hidrocoloides DuoDERM 10x10',
      presentacion: 'Caja x 5 unidades',
      stockActual: 2,
      consumoDiarioEstimado: 0.5,
      stockMinimo: 3,
      diasDisponibles: 4,
      estadoAlerta: 'Alerta Reposición (4 días)',
      severidad: 'warning'
    },
    {
      id: 'INS-002',
      patientId: 'PAC-001',
      nombre: 'Cánulas Nasales de Oxígeno para Adulto',
      presentacion: 'Unidad estéril',
      stockActual: 1,
      consumoDiarioEstimado: 0.15,
      stockMinimo: 2,
      diasDisponibles: 6,
      estadoAlerta: 'Alerta Reposición (6 días)',
      severidad: 'warning'
    },
    {
      id: 'INS-003',
      patientId: 'PAC-001',
      nombre: 'Gasas Estériles 10x10 en Sobres',
      presentacion: 'Paquete x 50 sobres',
      stockActual: 38,
      consumoDiarioEstimado: 3,
      stockMinimo: 15,
      diasDisponibles: 12,
      estadoAlerta: 'Stock Normal',
      severidad: 'success'
    },
    {
      id: 'INS-004',
      patientId: 'PAC-001',
      nombre: 'Pañales para Adulto Tamaño Grande (G)',
      presentacion: 'Bolsa x 30 unidades',
      stockActual: 8,
      consumoDiarioEstimado: 4,
      stockMinimo: 12,
      diasDisponibles: 2,
      estadoAlerta: 'URGENTE: Agotamiento inminente (48hs)',
      severidad: 'danger'
    },
    {
      id: 'INS-005',
      patientId: 'PAC-003',
      nombre: 'Guías de Suero Macrogotero con filtro',
      presentacion: 'Unidad estéril',
      stockActual: 3,
      consumoDiarioEstimado: 1,
      stockMinimo: 4,
      diasDisponibles: 3,
      estadoAlerta: 'Alerta Reposición (3 días)',
      severidad: 'warning'
    }
  ],

  traslados: [
    {
      id: 'TRAS-001',
      patientId: 'PAC-001',
      pacienteNombre: 'Roberto Carlos Gómez',
      fechaHora: '2024-03-20 10:00',
      tipoMovil: 'Móvil de Alta Complejidad (UTIM con Médico)',
      origen: 'Av. Rivadavia 6520, Caballito',
      destino: 'Sanatorio Güemes (Tomografía de Control Cerebro-Tórax)',
      motivo: 'Control post-ACV y evaluación de broncoaspiración',
      empresa: 'Emergencias Médicas S.A.',
      estado: 'Programado'
    }
  ],

  auditoriaFacturacion: [
    {
      id: 'AUD-001',
      patientId: 'PAC-001',
      pacienteNombre: 'Roberto Carlos Gómez',
      obraSocial: 'PAMI',
      periodo: 'Marzo 2024',
      nivelComplejidad: 'Alta Complejidad',
      modulosSolicitados: 'Módulo C (Alta Complejidad + Kinesiología Motora/Respiratoria + Fonoaudiología + Enfermería 12hs)',
      estado: 'Pendiente Dictamen',
      auditor: 'Dr. Federico Varela',
      montoEstimado: '$840.000 ARS',
      fechaSolicitud: '2024-03-01'
    },
    {
      id: 'AUD-002',
      patientId: 'PAC-002',
      pacienteNombre: 'Margarita Elena Rossi',
      obraSocial: 'OSDE',
      periodo: 'Marzo 2024',
      nivelComplejidad: 'Mediana Complejidad',
      modulosSolicitados: 'Módulo B (Mediana Complejidad + Kinesiología 3x/semana + Andador)',
      estado: 'Aprobado',
      auditor: 'Dra. Marcela Giménez',
      montoEstimado: '$480.000 ARS',
      fechaSolicitud: '2024-02-28',
      dictamenFecha: '2024-03-02',
      observaciones: 'Aprobado por 30 días para culminar protocolo de marcha independiente.'
    },
    {
      id: 'AUD-003',
      patientId: 'PAC-003',
      pacienteNombre: 'Juan Ignacio Peralta',
      obraSocial: 'Swiss Medical',
      periodo: 'Marzo 2024',
      nivelComplejidad: 'Baja Complejidad',
      modulosSolicitados: 'Módulo A (Infusiones EV Domiciliarias + Ceftriaxona)',
      estado: 'Aprobado',
      auditor: 'Dr. Fernando Castro',
      montoEstimado: '$320.000 ARS',
      fechaSolicitud: '2024-03-09',
      dictamenFecha: '2024-03-10',
      observaciones: 'Autorizado esquema ATB por 14 días con hemograma y función renal.'
    }
  ],

  incidentes: [
    {
      id: 'INC-001',
      patientId: 'PAC-001',
      pacienteNombre: 'Roberto Carlos Gómez',
      fechaHora: '2024-03-08 19:40',
      tipo: 'Extravasación Venosa Periférica',
      severidad: 'Moderada',
      descripcion: 'Durante la infusión de solución fisiológica se constata edema local y dolor en antebrazo derecho con extravasación leve.',
      acciones: 'Retiro inmediato de abbocath n° 20, compresa fría local, elevación de miembro y recolocación de acceso en miembro contralateral sin complicaciones.',
      reportante: 'Enf. Carla Romero',
      estado: 'Resuelto / Comité de Seguridad Informado'
    }
  ],

  usuarios: [
    {
      id: 'USR-001',
      email: 'admin@domicare.com',
      nombre: 'Lic. Ignacio Valenzuela',
      rol: 'Admin',
      descripcion: 'Acceso total a gestión médica, logística, finanzas, seguridad y auditoría'
    },
    {
      id: 'USR-002',
      email: 'dra.morales@domicare.com',
      nombre: 'Dra. Silvina Morales',
      rol: 'Médico Coordinador',
      descripcion: 'Coordinación médica, PAM, evolución clínica, indicación farmacológica y derivaciones'
    },
    {
      id: 'USR-003',
      email: 'enf.romero@domicare.com',
      nombre: 'Enf. Carla Romero',
      rol: 'Enfermería',
      descripcion: 'Visitas en domicilio, signos vitales, curaciones, administración y reporte de insumos'
    },
    {
      id: 'USR-004',
      email: 'lic.benitez@domicare.com',
      nombre: 'Lic. Martín Benítez',
      rol: 'Kinesiología/Rehabilitación',
      descripcion: 'Kinesioterapia respiratoria y motora, escalas funcionales y registro de visita'
    },
    {
      id: 'USR-005',
      email: 'auditor@prepaga.com',
      nombre: 'Dr. Federico Varela',
      rol: 'Auditor Médico',
      descripcion: 'Auditoría médica de Obras Sociales/Prepagas: dictamen de prórrogas y módulos'
    },
    {
      id: 'USR-006',
      email: 'logistica@domicare.com',
      nombre: 'Mariano Rossi',
      rol: 'Logística/Farmacia',
      descripcion: 'Control de stock domiciliario, aparatología en comodato y solicitud de ambulancias'
    }
  ]
};
